import { FunctionComponent } from 'react'

import {
  ALLOWED_TYPES_OF_SPORT,
  AllowedTypeOfSport,
  SportCompetitionScheduleApiProps,
  SportCompetitorScheduleApiProps,
  SportEntityScheduleAPIProps,
} from '@hooks/useSportEntitySchedule/types'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'
import SportCompetitionSchedule from '@components/SportEntitySchedule/SportCompetitionSchedule'
import SportCompetitorSchedule from '@components/SportEntitySchedule/SportCompetitorSchedule'

const isValidEntityId = (entityId?: string) => !!entityId && entityId !== '0'

const isCompetitionSchedule = (
  args: Record<string, unknown>,
): args is SportCompetitionScheduleApiProps =>
  args.entityType === 'competition' &&
  isValidEntityId(args.seasonId as string | undefined) &&
  ALLOWED_TYPES_OF_SPORT.includes(args.typeOfSport as AllowedTypeOfSport)

const isCompetitorSchedule = (
  args: Record<string, unknown>,
): args is SportCompetitorScheduleApiProps =>
  args.entityType === 'competitor' &&
  isValidEntityId(args.competitorId as string | undefined) &&
  ALLOWED_TYPES_OF_SPORT.includes(args.typeOfSport as AllowedTypeOfSport)

const SportEntitySchedule: FunctionComponent<SportEntityScheduleAPIProps> = (
  props,
) => {
  if (isCompetitionSchedule(props)) {
    return <SportCompetitionSchedule {...props} />
  }

  if (isCompetitorSchedule(props)) {
    return <SportCompetitorSchedule {...props} />
  }

  return null
}

const widget = {
  kind: ['sport-entity-schedule'],
  component: SportEntitySchedule,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
